import React from "react";
import btnStyle from "../../../../utils/buttonStyle.json"

type WelcomeProps = {
    question: {
        helpText: string;
        type: string;
        _id: string;
        imgUrl: string;
        questionText: string;
        cta: {
            _id: string;
            ctaType: string;
            linkedQuestionId: string;
            ctaText: string;
        }[];
    };
    updateUserResponse: (data: {
        questionType: string;
        questionText: string;
        nextQuestionId: string;
        _id: string;
        action?: string;
        answerResponse: Array<object>;
        selfieResponse: Array<object>;
        selfieID: string;
        userSelfie: string;
        timeStamp: number;
    }) => void;
};


const Welcome: React.FC<WelcomeProps> = ({ question, updateUserResponse }) => {

    const handleSubmitBtn = (cta: { _id: string; ctaType: string; linkedQuestionId: string; ctaText: string; }) => {
        updateUserResponse({
            questionType: question.type,
            questionText: question.questionText,
            nextQuestionId: cta?.linkedQuestionId || "",
            _id: question._id,
            action: cta?.ctaType,
            answerResponse: [],
            selfieResponse: [],
            selfieID: '',
            userSelfie: '',
            timeStamp: new Date().getTime()
        })
    }

    return (
        <div className={"tangent_welcome_screen_custom tangent_welcome_screen_mob_custom tngnt-flex tngnt-flex-col tngnt-items-center tngnt-gap-4 sm:tngnt-gap-6 tngnt-p-3 sm:tngnt-p-6 tngnt-pt-16 sm:tngnt-pt-16 tngnt-justify-center tngnt-w-[100%]"} id={`comp_${question._id}`}>
            {question.imgUrl ? <img src={question.imgUrl} alt="Welcome page image" className="tangent_welcome_image_custom tangent_welcome_image_mob_custom sm:tngnt-w-[60%] tngnt-w-[70%] tngnt-max-w-[inherit] tngnt-object-contain tngnt-max-h-[70vh]" /> : null}
            <div className='tangent_global_style tangent_global_style_custom tangent_welcome_text tangent_welcome_text_custom tangent_welcome_text_mob_custom tangent_question_text tngnt-text-center tngnt-text-[20px] tngnt-ml-[15px] tngnt-mr-[15px]' dangerouslySetInnerHTML={{ __html: question.questionText }} />
            {
                question.cta.map((cta) => {
                    return <button key={cta._id}
                        className={'tangent_global_style tangent_global_style_custom tangent_welcome_button_custom tangent_welcome_button_mob_custom app-btn-style primary_button tngnt-border tngnt-p-2 sm:tngnt-w-[50%] tngnt-w-[80%] tngnt-text-[16px] ' + btnStyle[cta.ctaType]}
                        onClick={() => handleSubmitBtn(cta)}> {cta.ctaText}</button>
                })
            }
            {
                question?.helpText && <div className="tangent_global_style tangent_global_style_custom tangent_helpText_custom tngnt-text-center tngnt-p-2 tngnt-mt-6 tngnt-text-[14px] tngnt-leading-[20px]" dangerouslySetInnerHTML={{ __html: question.helpText }}></div>
            }
        </div >
    )
}

export default Welcome